import "./custom-toast.css";
import { Icon } from "../../icons/icon";
import React, { useState } from "react";

export function CustomToast(props) {
  const [toastType, setToastType] = useState(props.type);

  function closeAlert() {
    setToastType(null);
    if (props.onClose) {
      props.onClose();
    }
  }
  if (!toastType) {
    return null;
  }

  return (
    <div className="toast-container">
      <div className={`toast ${toastType}`}>
        <div className="p-grid py-4">
          <div className="p-col-2">
            <div className={`icon-container ${toastType} cursor-pointer`}>
              {toastType === "error" && <Icon icon="circular-cancel" />}
              {toastType === "success" && <Icon icon="circular-success" />}
              {toastType === "warning" && <Icon icon="circular-warning" />}
            </div>
          </div>
          <div className="p-col-8">
            <div className="toast-text-container">
              <p className={`text-title ${toastType}`}>{props.title}</p>
              <p className="notification-text"> {props.description}</p>
            </div>
          </div>
          <div className="p-col-2">
            <button className="icon-container-cancel" onClick={closeAlert} type="button">
              {toastType === "error" && <Icon icon="cancel" />}
              {toastType === "success" && <Icon icon="cancel-success" />}
              {toastType === "warning" && <Icon icon="cancel-warning" />}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
